import React from 'react'
import PropTypes from 'prop-types'

function Icon({ content = undefined }) {
  if (!content) {
    return null
  }

  if (typeof content === 'string') {
    return <i className={content} />
  }

  return content
}

Icon.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default Icon
